export default __webpack_public_path__ + "static/media/ATSSync.f117fa0c.svg";